import axios from 'axios'
import { host } from '../../configuraciones'
import { v4 as uuidv4 } from 'uuid';

//constantes
const dataInicial = {
    data: {
        fc_01_solicitudderegistro: [],
        fc_05_solicitudusomarcaeimagen: [],
        fc_06_registrodemaguey: [],
        fc_08_solicitudrenvacioncertificados: [],
        fc_09_solicitudemicioncertificadonomexportacionyentregahologram: [],
        fc_30_notificaciontrasladodeproducto: [],
        fc_31_solicitudseguimiento: [],
        fc_33_solicitudenvasadonacional: [],
        fc_34_notificacionsuspencionyreactivacion: [],
        fc_35_notificaciondeserviciosvarios: [],
        fc_36_solicituddeactualizacion: [],
        fc_40_solicituddeadquisiciondehologramas: [],
        fc_41_solicitudparabebidasconmezcal: []
    },
    status: 0,
    detalle: {},
    certificados: {},
    revision: false,
    formato: {},
    modoAtencionACliente: false,
    formatoPrincipalDetalle: {},
    anexosDetalle: {},
    revisores: [],
    datosPrincipal: [],
    clientes:[],
    usuariosBeneficiarios:[]
}

//types
const OBTENER_TODAS_LAS_SOLICITUDES_ERROR = 'OBTENER_TODAS_LAS_SOLICITUDES_ERROR'
const OBTENER_TODAS_LAS_SOLICITUDES_STATUS_EXITO = 'OBTENER_TODAS_LAS_SOLICITUDES_STATUS_EXITO'
const ACTUALIZAR_FORMATOS_EXITO = 'ACTUALIZAR_FORMATOS_EXITO'
const OBTENER_TODAS_LOS_CERTIFICADOS_STATUS_EXITO = 'OBTENER_TODAS_LOS_CERTIFICADOS_STATUS_EXITO'
const OBTENER_UNA_SOLICITUID_DETALLE_EXITO = 'OBTENER_UNA_SOLICITUID_DETALLE_EXITO'
const OBTENER_SOLICITUDES_ERROR = 'OBTENER_SOLICITUDES_ERROR'
const OBTENER_SOLICITUID_DETALLE_EXITO = 'OBTENER_SOLICITUID_DETALLE_EXITO'
const AGREGAR_OBSERVACIONES_EXITO = 'AGREGAR_OBSERVACIONES_EXITO'
const OBTENER_ANEXOS_DE_SOLICITUID_DETALLE_EXITO = 'OBTENER_ANEXOS_DE_SOLICITUID_DETALLE_EXITO'
const OBTENER_DATOS_LOGIN_EXITO = 'OBTENER_DATOS_LOGIN_EXITO'
const OBTENER_DATOS_LOGIN_ERROR = 'OBTENER_DATOS_LOGIN_ERROR'
const OBTENER_CLIENTES_EXITO = 'OBTENER_CLIENTES_EXITO'

//redcuer
export default function AtencionClientesReducer(state = dataInicial, action) {
    switch (action.type) {
        case OBTENER_TODAS_LAS_SOLICITUDES_STATUS_EXITO:

            return { ...state, data: action.payload.data, status: action.payload.status, revision: false }
        case OBTENER_TODAS_LAS_SOLICITUDES_ERROR:
            return { ...state }
        case ACTUALIZAR_FORMATOS_EXITO:
            return { ...state, detalle: action.payload, revision: action.payload.revision }
        case OBTENER_TODAS_LOS_CERTIFICADOS_STATUS_EXITO:
            return { ...state, certificados: action.payload }
        case OBTENER_UNA_SOLICITUID_DETALLE_EXITO:
            return { ...state, detalle: action.payload.detalle }
        case OBTENER_SOLICITUID_DETALLE_EXITO:
            return { ...state, formato: action.payload.detalle, modoAtencionACliente: true }
        case OBTENER_SOLICITUDES_ERROR:
            return { ...state }
        case AGREGAR_OBSERVACIONES_EXITO:
            return { ...state }
        case OBTENER_ANEXOS_DE_SOLICITUID_DETALLE_EXITO:
            return { ...state, anexosDetalle: action.payload.anexosDetalle, datosPrincipal: action.payload.datosPrincipal }
        case OBTENER_DATOS_LOGIN_EXITO:
            return { ...state, revisores: action.payload.revisores }
        case OBTENER_CLIENTES_EXITO:
            return { ...state, clientes: action.payload.clientes }
        default:
            return state
    }
}

//acciones
export const obtenerTodasLasSolicitudesWithStatusEnviado = (params) => async (dispatch) => {
    try {
        const fullUrl = host + `Estatus/obtenerTodasLasSolicitudesConEstatus/estatus=${params.status}`
        const res = await axios.get(fullUrl)

        dispatch({
            type: OBTENER_TODAS_LAS_SOLICITUDES_STATUS_EXITO,
            payload: { data: res.data.data, status: params.status }

        })
        return res
    } catch (error) {
        console.log(error)
        dispatch({
            type: OBTENER_TODAS_LAS_SOLICITUDES_ERROR
        })
    }

}
export const obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado = (params) => async (dispatch) => {
    try {
        const fullUrl = host + `Estatus/obtenerTodasLasSolicitudesEjecutivoConEstatus/estatus=${params.status}&revisor=${params.revisor}&idLogin=${params.idLogin}`
        const res = await axios.get(fullUrl)
        dispatch({
            type: OBTENER_TODAS_LAS_SOLICITUDES_STATUS_EXITO,
            payload: { data: res.data.data, status: params.status }

        })
        return res
    } catch (error) {
        console.log(error)
        dispatch({
            type: OBTENER_TODAS_LAS_SOLICITUDES_ERROR
        })
    }

}
//actualizar los formatos para en proceso
export const AcualizarFormatoAccion = (data) => async (dispatch) => {
    try {
        const fullUrl = host + `Estatus/actualizarEstatusRevisar`
        const res = await axios.post(fullUrl, { data })
        const dato = await dispatch({
            type: ACTUALIZAR_FORMATOS_EXITO,
            payload: { detalle: { data }, revision: data.revision }
        })
        return res
    } catch (error) {
        console.log(error)
    }
}
export const obtenertodosLosCertificadosPorId = (id) => async (dispatch) => {
    try {
        const fullUrl = host + `InformacionValida/obtenerCertificado/=${id}`
        const res = await axios.get(fullUrl)
        dispatch({
            type: OBTENER_TODAS_LOS_CERTIFICADOS_STATUS_EXITO,
            payload: { certificados: res.data.data }
        })
        return res
    } catch (error) {
        console.log(error)
        dispatch({
            type: OBTENER_TODAS_LAS_SOLICITUDES_ERROR
        })
    }

}
export const obetenerSolicitudDetalle = (data) => async (dispatch) => {
    try {
        const fullUrl = host + data.row.uri + data.row.id
        const res = await axios.get(fullUrl)
        dispatch({
            type: OBTENER_UNA_SOLICITUID_DETALLE_EXITO,
            payload: { detalle: res.data.data }
        })
    } catch (error) {
        console.log(error)
        dispatch({
            type: OBTENER_SOLICITUDES_ERROR
        })

    }
}

export const obetenerFormatoDetalle = (uri, idSolicitud) => async (dispatch) => {
    try {
        const fullUrl = host + uri + idSolicitud
        const res = await axios.get(fullUrl)

        //FC_01
        for (let i in res.data.data.fc_01_anexounidaddealmacen) {
            res.data.data.fc_01_anexounidaddealmacen[i]['id'] = uuidv4()
        }

        for (let i in res.data.data.fc_01_anexounidaddeenvasado) {
            res.data.data.fc_01_anexounidaddeenvasado[i]['id'] = uuidv4()
        }

        for (let i in res.data.data.fc_01_anexounidaddeproduccion) {
            res.data.data.fc_01_anexounidaddeproduccion[i]['id'] = uuidv4()
        }

        for (let i in res.data.data.fc_01_anexopersonaautorizadatramites) {
            res.data.data.fc_01_anexopersonaautorizadatramites[i]['id'] = uuidv4()
        }

        for (let i in res.data.data.fc_01_anexomarcas) {
            res.data.data.fc_01_anexomarcas[i]['id'] = uuidv4()
        }


        //FC_36
        for (let i in res.data.data.fc_36_anexounidaddealmacen) {
            res.data.data.fc_36_anexounidaddealmacen[i]['id'] = uuidv4()
        }

        for (let i in res.data.data.fc_36_anexounidaddeenvasado) {
            res.data.data.fc_36_anexounidaddeenvasado[i]['id'] = uuidv4()
        }

        for (let i in res.data.data.fc_36_anexounidaddeproduccion) {
            res.data.data.fc_36_anexounidaddeproduccion[i]['id'] = uuidv4()
        }
        dispatch({
            type: OBTENER_SOLICITUID_DETALLE_EXITO,
            payload: { detalle: res.data.data, modoAtencionACliente: true }
        })
        return res
    } catch (error) {
        console.log(error)
        dispatch({
            type: OBTENER_SOLICITUDES_ERROR
        })

    }
}
export const obetenerAnexosDetalle = (data) => async (dispatch) => {
    try {
        const fullUrl = host + data.row.uriAnexos + data.row.id
        const res = await axios.get(fullUrl)
        const datosGenerales = [
            res.data.data.nombrerazonsocial, res.data.data.rfc, res.data.data.telefono,
            res.data.data.correoelectronico, res.data.data.viverista, res.data.data.productormaguey,
            res.data.data.productormezcal, res.data.data.envasador, res.data.data.comercializadormezcal,
        ]
        const anexo = res.data.data.anexo
        const fc_01_anexomarcas = res.data.data.fc_01_anexomarcas
        const fc_01_anexomarcasproductoconmezcal = res.data.data.fc_01_anexomarcasproductoconmezcal
        const fc_01_anexomediosdecontacto = res.data.data.fc_01_anexomediosdecontacto
        const fc_01_anexopersonaautorizadatramites = res.data.data.fc_01_anexopersonaautorizadatramites
        const fc_01_anexopredios = res.data.data.fc_01_anexopredios
        const fc_01_anexoproductor = res.data.data.fc_01_anexoproductor
        const fc_01_anexorepresentantelegal = res.data.data.fc_01_anexorepresentantelegal
        const fc_01_anexos = res.data.data.fc_01_anexos
        const fc_01_anexounidaddealmacen = res.data.data.fc_01_anexounidaddealmacen
        const fc_01_anexounidaddeenvasado = res.data.data.fc_01_anexounidaddeenvasado
        const fc_01_anexounidaddeproduccion = res.data.data.fc_01_anexounidaddeproduccion
        const anexos = {
            anexo, fc_01_anexomarcas, fc_01_anexomarcasproductoconmezcal,
            fc_01_anexomediosdecontacto, fc_01_anexopersonaautorizadatramites,
            fc_01_anexopredios, fc_01_anexoproductor, fc_01_anexorepresentantelegal,
            fc_01_anexos, fc_01_anexounidaddealmacen, fc_01_anexounidaddeenvasado,
            fc_01_anexounidaddeproduccion
        }
        dispatch({
            type: OBTENER_ANEXOS_DE_SOLICITUID_DETALLE_EXITO,
            payload: { anexosDetalle: res.data.data, datosPrincipal: datosGenerales }
        })
    } catch (error) {
        console.log(error)
        dispatch({
            type: OBTENER_SOLICITUDES_ERROR
        })

    }
}
export const obtenerDatosLogin = () => async (dispatch) => {
    try {
        const fullUrl = host + 'AnexoUsuario/obtenerTodosDatosLoginDeLogin'
        const res = await axios.get(fullUrl)
        let usuarios = []
        for (const usuario of res.data.data) {
            if (usuario.datoslogin !== null) {
                usuarios.push(usuario)
            }
        }
        dispatch({
            type: OBTENER_DATOS_LOGIN_EXITO,
            payload: { revisores: usuarios }
        })
        // const datosLogin =[]
        // for(const dato of res.data.data){
        //     datosLogin.push(dato.dat)
        // }
        return usuarios
    } catch (error) {
        console.log(error)
        dispatch({
            type: OBTENER_DATOS_LOGIN_ERROR
        })

    }
}
export const actualizarSolicitud = (data) => async (dispatch) => {
    try {
        const datos = { data: data }
        const fullUrl = host + 'AtencionAClientes/actualizarSolicitud'
        const res = await axios.put(fullUrl, datos)
        // dispatch({
        //     type: OBTENER_ANEXOS_DE_SOLICITUID_DETALLE_EXITO,
        //     payload: { anexosDetalle: res.data.data }
        // })
    } catch (error) {
        console.log(error)
        dispatch({
            type: OBTENER_SOLICITUDES_ERROR
        })

    }
}
export const obtenerTodosClientes = () => async (dispatch) => {
    try {
        const fullUrl = host + `InformacionValida/obtenerAllCliente`
        const res = await axios.get(fullUrl)
        dispatch({
            type: OBTENER_CLIENTES_EXITO,
            payload: { clientes: res.data.data }
        })
        return res
    } catch (error) {
        console.log(error);
    }
}
export const actualizarSolicitudes = (data) => async (dispatch) => {
    try {
        const datos = { data: data }
        const fullUrl = host + 'AtencionAClientes/actualizarSolicitudes'
        const res = await axios.put(fullUrl, datos)
    } catch (error) {
        console.log(error)
        dispatch({
            type: OBTENER_SOLICITUDES_ERROR
        })
    }
}

export const actualizarObservacion = (data) => async (dispatch) => {
    try {
        const datos = { ...data }
        const fullUrl = host + 'AtencionAClientes/actualizarObservacionFormato'
        const res = await axios.put(fullUrl, datos)
        dispatch({ type: AGREGAR_OBSERVACIONES_EXITO })
        return res
    } catch (error) {
        console.log(error)
        dispatch({ type: OBTENER_SOLICITUDES_ERROR })
    }
}

export const obtenerObservacion = (data) => async (dispatch) => {
    try {
        const fullUrl = host + `AtencionAClientes/obtenerObservacionFormato/${data.tabla}&${data.id}&${data.idname}`
        const res = await axios.get(fullUrl)
        return res
    } catch (error) {
        console.log(error)
        dispatch({ type: OBTENER_SOLICITUDES_ERROR })
    }
}
